(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('company', {
            // parent: 'entity',
            parent: 'app',
            url: '/company?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI'],
                pageTitle: 'ccsTrApp.company.home.title',
                title: 'Companies'
            },
            views: {
                'company@': {
                    templateUrl: 'app/entities/company/companies.html',
                    controller: 'CompanyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('company');
                    $translatePartialLoader.addPart('compType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('company-detail', {
            parent: 'app',
            url: '/company/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI'],
                pageTitle: 'ccsTrApp.company.detail.title',
                title: 'Detail'
            },
            views: {
                'company-detail@': {
                    templateUrl: 'app/entities/company/company-detail-view.html',
                    controller: 'CompanyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('company');
                    $translatePartialLoader.addPart('compType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Company', function($stateParams, Company) {
                    return Company.get({id : $stateParams.id}).$promise;
                }],
                entityAudit: ['$stateParams', 'CompanyAudit', function($stateParams, CompanyAudit) {
                    return CompanyAudit.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'company',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('company-detail.edit', {
            // parent: 'company-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/company/detail/edit/{id}',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }],
                        showTypes: function () {
                            return true;
                        }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company.new', {
            // parent: 'company',
            parent: 'app',
            // url: '/new',
            url: '/company/new',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdOn: new Date(),
                                createdBy: null,
                                modifiedOn: new Date(),
                                modifiedBy: null,
                                name: null,
                                shortName: null,
                                accountNum: null,
                                type: null,
                                id: null
                            };
                        },
                        showTypes: function () {
                            return true;
                        }
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: true });
                }, function() {
                    $state.go('company');
                });
            }]
        })
        .state('company.edit', {
            // parent: 'company',
            parent: 'company',
            // url: '/{id}/edit',
            url: '/company/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }],
                        showTypes: function () {
                            return true;
                        }
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company.delete', {
            // parent: 'company',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/company/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TUI']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company/company-delete-dialog.html',
                    controller: 'CompanyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Company', function(Company) {
                            return Company.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('company', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );

    }

})();
